module.exports = __webpack_public_path__ + "img/banner_brand.3db1f70d.png";